module.exports = __webpack_public_path__ + "img/pause-icon.c94ee2c3.svg";